/** Shared countdown / TBA wording for markets (browse cards, detail, engine). */

export function formatMarketResolutionCountdown(iso?: string | null): string {
  if (iso == null || String(iso).trim() === '') {
    return 'TBA';
  }
  const end = new Date(iso);
  if (Number.isNaN(end.getTime())) {
    return 'TBA';
  }
  const now = new Date();
  const diff = end.getTime() - now.getTime();
  if (diff <= 0) return 'Ended';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (days > 0) return `Ends in ${days}d ${hours}h`;
  if (hours > 0) return `Ends in ${hours}h ${minutes}m`;
  return `Ends in ${minutes}m`;
}
